"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const templates_1 = require("@home-health-notify/templates");
const lodash_1 = require("lodash");
const Urls_1 = require("../Urls");
class OrganizationAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    updateUserProfile(userProfileData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.userProfileUpdate, userProfileData);
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`updateUserProfile => ${response.toString()}`);
            }
        });
    }
    updateSettings(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.userSettings, data);
            if (response.status === 200) {
                return response.data.data.settings;
            }
            else {
                throw new Error(`updateSettings => ${response.toString()}`);
            }
        });
    }
    updateOrgSettings(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.adminSettings, request);
            if (response.status !== 200) {
                throw new Error(`updateOrgSettings => ${response.toString()}`);
            }
        });
    }
    getAutoAckEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.autoAckEvents);
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`getAutoAckEvents => ${response.toString()}`);
            }
        });
    }
    getAutoAckRules() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.autoAckRules);
            if (response.status === 200) {
                return (_b = (_a = response.data.data) === null || _a === void 0 ? void 0 : _a.rules) !== null && _b !== void 0 ? _b : [];
            }
            else {
                throw new Error(`getAutoAckRules => ${response.toString()}`);
            }
        });
    }
    // PUT replaces the full rules array — there is no per-rule endpoint.
    replaceAutoAckRules(rules) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.autoAckRules, { rules });
            if (response.status === 200) {
                return (_b = (_a = response.data.data) === null || _a === void 0 ? void 0 : _a.rules) !== null && _b !== void 0 ? _b : [];
            }
            else {
                throw new Error(`replaceAutoAckRules => ${response.toString()}`);
            }
        });
    }
    getOrgGeneralSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.orgGeneralSettings);
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`getOrgGeneralSettings => ${response.toString()}`);
            }
        });
    }
    updateOrgGeneralSettings(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.orgGeneralSettings, request);
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`updateOrgGeneralSettings => ${response.toString()}`);
            }
        });
    }
    getOrganizations() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.workspace);
            if (response.status === 200) {
                return response.data.data;
            }
            //TODO: Need to handle other http status codes received from axios.
            else {
                throw new Error(`getOrganizations => ${response.toString()}`);
            }
        });
    }
    fetchOrganizationMedia(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl +
                    Urls_1.urls.organizationMedia +
                    this.organizationMediaQueryString(params), {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                if (response.status === 200) {
                    return (0, domain_1.CompletedResult)(response.data.data);
                }
                //TODO: Need to handle other http status codes received from axios.
                else {
                    throw new Error(`fetchOrganizationMedia => ${response.toString()}`);
                }
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    organizationMediaQueryString(params) {
        var _a;
        const query = new URLSearchParams();
        if (params.limit) {
            query.append("limit", String(params.limit));
        }
        if (params.pageNo) {
            query.append("pageNo", String(params.pageNo));
        }
        if (params.search) {
            query.append("search", params.search);
        }
        if ((_a = params.type) === null || _a === void 0 ? void 0 : _a.length) {
            params.type.forEach(item => {
                query.append("type", item);
            });
        }
        return `?${query.toString()}`;
    }
    fetchAllTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            const template = (0, lodash_1.cloneDeep)(templates_1.TEMPLATES_SCHEMAS);
            return Promise.resolve(template);
        });
    }
    getQuickReplies() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.quickReplies);
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`getQuickReplies => ${response.toString()}`);
            }
        });
    }
    addQuickReplies(quickReply) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.quickReplies, { quickReply });
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`addQuickReplies => ${response.toString()}`);
            }
        });
    }
    deleteQuickReplies(index) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpAdapter.delete(this.config.baseUrl + Urls_1.urls.quickReplies, { data: { index } });
            if (response.status === 200) {
                return response.data.data;
            }
            else {
                throw new Error(`deleteQuickReplies => ${response.toString()}`);
            }
        });
    }
}
exports.OrganizationAdapter = OrganizationAdapter;
